export const paddingDefaults = {
	pageBorder: '3em',
	topBottom: '8em',
}

export const lineWidths = {
	ctaUnderline: '6',
	signUp: '4'
}
